import { render, staticRenderFns } from "./ModalDescription.vue?vue&type=template&id=08ac5d08&scoped=true"
import script from "./ModalDescription.vue?vue&type=script&lang=js"
export * from "./ModalDescription.vue?vue&type=script&lang=js"
import style0 from "./ModalDescription.vue?vue&type=style&index=0&id=08ac5d08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac5d08",
  null
  
)

export default component.exports